import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Col,
  Row,
  Input,
  Button,
  message,
  Modal,
  Tag,
  Divider,
  Switch,
  Checkbox,
} from "antd";
import ClickableTextButton from "components/ClickableTextButton/ClickableTextButton";
import Title from "components/Title/Title";
import { withAppContext } from "contexts/AppContext/AppContext";
import moment from "moment";
import Currency from "react-currency-formatter";
import { PrimaryColor, ScreenSize } from "utils/constants";
import "./buttonRGB.css";
import {
  cancelUserSubscription,
  createCheckOutSession,
  getUserSubscription,
  patchUserSubscription,
} from "apis/billing";
import { getAllProducts } from "apis/product";
import { useLocation } from "react-router-dom";
import queryString from "query-string";

const BillingSubscriptionSpecial = (props) => {
  const history = useHistory();
  const user = props.getLoggedInUser();
  const { search } = useLocation();

  const values = queryString.parse(search);

  // console.log(user, "user");
  const [userSubscription, setUserSubscription] = useState([]);

  const [loading, setLoading] = useState(false);
  const [monthlyAnnual, setMonthlyAnnual] = useState(false);
  const [selectPlan, setSelectPlan] = useState("");
  const [selectPrice, setSelectPrice] = useState(0);
  const [selectPriceId, setSelectPriceId] = useState("");
  const [selectCurrency, setSelectCurrency] = useState("myr");
  const [selectPlanId, setSelectPlanId] = useState("");
  const [selectPlanObject, setSelectPlanObject] = useState({});
  const [voucherCode, setVoucherCode] = useState("");
  const [checkTnc, setCheckTnc] = useState(false);

  const [planList, setPlanList] = useState([]);

  const onBackButtonClick = () => {
    window.location.assign("/billing");
  };

  useEffect(() => {
    console.log("props", props);
    getProductList();
    return () => {};
  }, []);

  const getProductList = async () => {
    const mode = "special";
    var res = await getAllProducts(mode);
    if (res.status === 200) {
      // Handle plan if no longer available
      if (res.products.length === 0) {
        res = await getAllProducts();
        Modal.info({
          title: "Subscribed plan no longer available",
          content:
            "The subscribed plan is no longer available. Please select a new plan or contact support for more info.",
        });
        return setPlanList(res.products);
      }
      const data = [...res.products];
      data.forEach((element) => {
        if (element.recommended) {
          if (monthlyAnnual) {
            setSelectPlan(element.name);
            setSelectPrice(element.pricePerYear);
            setSelectPriceId(element.stripePriceIdAnually);
            setSelectPlanId(element._id);
            setSelectPlanObject(element);
          } else {
            setSelectPlan(element.name);
            setSelectPrice(element.pricePerMonth);
            setSelectPriceId(element.stripePriceIdMonthly);
            setSelectPlanId(element._id);
            setSelectPlanObject(element);
          }
        }
      });

      const productId = values.productId;

      var filteredData = [];

      if (productId) {
        filteredData = data.filter((product) => {
          if (product._id === productId) {
            return product;
          }
        });
        if (monthlyAnnual) {
          setSelectPlan(filteredData[0].name);
          setSelectPrice(filteredData[0].pricePerYear);
          setSelectPriceId(filteredData[0].stripePriceIdAnually);
          setSelectPlanId(filteredData[0]._id);
          setSelectPlanObject(filteredData[0]);
        } else {
          setSelectPlan(filteredData[0].name);
          setSelectPrice(filteredData[0].pricePerMonth);
          setSelectPriceId(filteredData[0].stripePriceIdMonthly);
          setSelectPlanId(filteredData[0]._id);
          setSelectPlanObject(filteredData[0]);
        }
      } else {
        filteredData = [];
      }

      setPlanList(filteredData);
      getCurrentSubscription(res.products);
    }
  };

  const getCurrentSubscription = async (products) => {
    const currentSubscription = await props.getLoggedInUserSubscription();

    if (currentSubscription.length > 0) {
      const now = Math.floor(Date.now() / 1000);

      setUserSubscription(currentSubscription);

      if (currentSubscription.length > 0) {
        const findSubMonthly = products.find(
          (obj) => obj.stripePriceIdMonthly === currentSubscription[0].priceId
        );

        const findSubAnnually = products.find(
          (obj) => obj.stripePriceIdAnually === currentSubscription[0].priceId
        );

        if (findSubMonthly) {
          setSelectPlan(findSubMonthly.name);
          setSelectPrice(findSubMonthly.pricePerMonth);
          setSelectPriceId(findSubMonthly.stripePriceIdMonthly);
          setSelectPlanId(findSubMonthly._id);
          setSelectPlanObject(findSubMonthly);
          setMonthlyAnnual(false);
        }

        if (findSubAnnually) {
          setSelectPlan(findSubAnnually.name);
          setSelectPrice(findSubAnnually.pricePerYear);
          setSelectPriceId(findSubAnnually.stripePriceIdAnually);
          setSelectPlanId(findSubAnnually._id);
          setSelectPlanObject(findSubAnnually);
          setMonthlyAnnual(true);
        }
      }
    }
  };

  const HandleCheckOut = async () => {
    Modal.confirm({
      title: "Proceed to Checkout?",
      onOk: async () => {
        const payload = {
          priceId: selectPriceId,
          userEmail: user.email,
          trial: selectPlanObject.trial,
          processingFee: selectPlanObject.processingFee,
          voucherCode: voucherCode,
          invoiceDescription: selectPlanObject.invoiceDescription,
          role: selectPlanObject.role,
          domain: window.location.origin,
        };

        if (payload.trial) {
          // payload.trialDuration = selectPlanObject.trialDuration;
          payload.trialEndDate = selectPlanObject.trialEndDate;
        }

        createCheckOutSession(payload)
          .then((res) => {
            if (res.status === 200) {
              message.success("Checkout session successfully created!");
              console.log("res", res);
              setTimeout(() => {
                window.location.assign(res.redirectUrl);
              }, 250);
            }
          })
          .catch((ex) => {
            console.log("error", ex);

            message.error("Invalid Voucher Code");

            // Modal.error({
            //   title: ex.message,
            // });
          });
      },
    });
  };

  const ChangeSubscription = async () => {
    Modal.confirm({
      title: "Are you sure you want to change your subscription?",
      onOk: async () => {
        const payload = {
          priceId: selectPriceId,
          voucherCode: voucherCode,
          productId: selectPlanObject.stripeProductId,
          trialEndDate: selectPlanObject.trialEndDate,
        };

        patchUserSubscription(payload)
          .then((res) => {
            if (res.status === 200) {
              message.success("Your subscription is updated successully!");
              console.log("res", res);
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          })
          .catch((ex) => {
            Modal.error({
              title: ex.message,
            });
          });
      },
    });
  };

  const CancelSubscription = async (status) => {
    Modal.confirm({
      width: 800,
      content:
        status === "past_due"
          ? "Note that your current subscription will be canceled immediately and you will lose access to the resources provided by your current subscription. Past subscription fees won't be refunded."
          : `Note that your current subscription will be canceled on ${moment
              .unix(userSubscription[0].endDate)
              .format(
                "YYYY-MM-DD"
              )} and you will lose access to the resources provided by your current subscription. Past subscription fees won't be refunded.`,
      // content:
      //   "Note that your current subscription will be canceled immediately and you will lose access to the resources provided by your current subscription. Past subscription fees won't be refunded.",
      title: "Are you sure you want to cancel your subscription? ",
      onOk: async () => {
        cancelUserSubscription()
          .then((res) => {
            if (res.status === 200) {
              message.success("Your subscription has been cancel successully!");
              console.log("res", res);
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          })
          .catch((ex) => {
            Modal.error({
              title: ex.message,
            });
          });
      },
    });
  };

  return (
    <div>
      <Row
        justify="space-between"
        align="middle"
        style={{ marginBottom: "32px" }}
      >
        <ClickableTextButton
          text="Back"
          onClick={onBackButtonClick}
          showIcon={true}
          type="back"
        />
      </Row>
      <Title marginBottom="32px">Billing Subscription</Title>

      <Row gutter={24}>
        <Col xs={24} md={24} xl={18}>
          <div
            style={{
              padding: 16,
              border: "1px solid #e9e9e9",
              borderRadius: 2,
              marginBottom: window.innerWidth < ScreenSize.xl && 24,
            }}
          >
            <Row justify="space-between" align="middle">
              <Col style={{ fontSize: 24, fontWeight: "bold", color: "black" }}>
                Licenses
              </Col>

              <Col>
                <Row>
                  <div
                    style={{
                      marginRight: 8,
                      fontWeight: monthlyAnnual ? "normal" : "bold",
                    }}
                  >
                    Monthly
                  </div>
                  <Switch
                    // checkedChildren={"Annual"}
                    // unCheckedChildren="Monthly"
                    style={{
                      backgroundColor: monthlyAnnual && PrimaryColor,
                    }}
                    disabled={planList.length === 0 ? true : false}
                    checked={monthlyAnnual}
                    onChange={(e) => {
                      setMonthlyAnnual(e);

                      if (e) {
                        const SelectPlanList = planList.findIndex(
                          (obj) => obj._id === selectPlanId
                        );

                        setSelectPlanId(planList[SelectPlanList]._id);
                        setSelectPlan(planList[SelectPlanList].name);
                        setSelectPrice(planList[SelectPlanList].pricePerYear);
                        setSelectPriceId(
                          planList[SelectPlanList].stripePriceIdAnually
                        );
                        setSelectPlanObject(planList[SelectPlanList]);
                      } else {
                        const SelectPlanList = planList.findIndex(
                          (obj) => obj._id === selectPlanId
                        );

                        setSelectPlanId(planList[SelectPlanList]._id);
                        setSelectPlan(planList[SelectPlanList].name);
                        setSelectPrice(planList[SelectPlanList].pricePerMonth);
                        setSelectPriceId(
                          planList[SelectPlanList].stripePriceIdMonthly
                        );
                        setSelectPlanObject(planList[SelectPlanList]);
                      }
                    }}
                  />
                  <div
                    style={{
                      marginLeft: 8,
                      fontWeight: monthlyAnnual ? "bold" : "normal",
                    }}
                  >
                    Annually
                  </div>
                  <Tag
                    style={{
                      marginLeft: 8,
                      borderTopRightRadius: 10,
                      borderBottomLeftRadius: 10,
                    }}
                    color="#298469"
                  >
                    Save up to 20%
                  </Tag>
                </Row>
              </Col>
            </Row>

            <Divider />

            <Row justify="center" gutter={24}>
              {planList.map((value) => (
                <Col
                  key={value._id}
                  xs={24}
                  md={24}
                  xl={planList.length === 2 ? 12 : 8}
                  style={{
                    marginBottom: 24,
                  }}
                >
                  <div
                    style={{
                      padding: 16,
                      border:
                        selectPlan === value.name
                          ? `2px solid ${PrimaryColor}`
                          : "2px solid rgba(0,0,0,0.15)",
                      backgroundColor: selectPlan === value.name && "#D7a30130",
                      borderRadius: 10,
                      height: "100%",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setSelectPlanObject(value);
                      setSelectPlanId(value._id);
                      setSelectPlan(value.name);
                      setSelectCurrency(value.currency);
                      if (monthlyAnnual) {
                        setSelectPrice(value.pricePerYear);
                        setSelectPriceId(value.stripePriceIdAnually);
                      } else {
                        setSelectPrice(value.pricePerMonth);
                        setSelectPriceId(value.stripePriceIdMonthly);
                      }

                      if (window.innerWidth < ScreenSize.xl) {
                        window.location.assign("#summary");
                      }
                    }}
                  >
                    {value.recommended ? (
                      <Row justify="center">
                        <Col
                          style={{
                            fontSize:
                              window.innerWidth < 1600
                                ? window.innerWidth < 1400
                                  ? 13
                                  : 14
                                : 17,
                            fontWeight: "bold",
                            color: "black",
                            backgroundColor: "#D7a30180",
                            border: "1px solid #D7A301",
                            padding:
                              window.innerWidth < 1600
                                ? "8px 12px"
                                : "12px 24px",
                            borderRadius: 100,
                            fontStyle: "italic",
                            textAlign: "center",
                            height:
                              window.innerWidth < 1600
                                ? window.innerWidth < 1400
                                  ? 38
                                  : 40
                                : 53,
                          }}
                        >
                          Recommended
                        </Col>
                      </Row>
                    ) : (
                      <div style={{ height: 53 }}></div>
                    )}

                    <Row justify="center">
                      <div
                        style={{
                          fontSize: 32,
                          fontWeight: 500,
                          color: "black",
                          textAlign: "center",
                        }}
                      >
                        {value.name}
                      </div>
                    </Row>
                    <Row
                      justify="center"
                      style={{
                        fontSize: 36,
                        fontWeight: "bold",
                        color: "black",
                      }}
                    >
                      <Currency
                        quantity={
                          monthlyAnnual
                            ? value.pricePerYear / 100
                            : value.pricePerMonth / 100
                        }
                        currency={value.currency}
                        pattern="!###,###.00"
                      />
                    </Row>

                    <Row justify="center" style={{ fontWeight: 500 }}>
                      {monthlyAnnual
                        ? "per license per year"
                        : "per license per month"}
                    </Row>
                    {/* <Row
                      justify="center"
                      style={{
                        fontSize: 16,
                        fontWeight: "bold",
                        textAlign: "center",
                        height: 65,
                      }}
                    >
                      <Typography.Paragraph
                        ellipsis={{
                          rows: 2,
                        }}
                      >
                        ALL {value.name.toUpperCase()} features plus...
                      </Typography.Paragraph>
                    </Row> */}

                    <Divider />

                    <Row
                      style={{ textAlign: "left", lineHeight: 2 }}
                      gutter={16}
                    >
                      {value.description.map((description, index) => {
                        return (
                          <Col span={24} key={index}>
                            {" "}
                            - {description}
                          </Col>
                        );
                      })}
                    </Row>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </Col>

        <Col xs={24} md={24} xl={6}>
          <div
            style={{
              padding: 16,
              border: "1px solid #e9e9e9",
              borderRadius: 2,
            }}
          >
            <div>
              <div
                id="summary"
                style={{ fontSize: 24, fontWeight: "bold", color: "black" }}
              >
                Summary
              </div>

              <Divider />

              <div style={{ fontSize: 18, fontWeight: 500 }}>Renewal Date</div>

              <div
                style={{
                  fontWeight: 500,
                  color: "rgba(0,0,0,0.45)",
                  marginBottom: 16,
                }}
              >
                {monthlyAnnual
                  ? userSubscription.length > 0 &&
                    selectPriceId === userSubscription[0].priceId
                    ? moment
                        .unix(userSubscription[0].endDate)
                        .format("MMM DD,YYYY")
                    : moment().add(1, "year").format("MMM DD,YYYY")
                  : userSubscription.length > 0 &&
                    selectPriceId === userSubscription[0].priceId
                  ? moment
                      .unix(userSubscription[0].endDate)
                      .format("MMM DD,YYYY")
                  : moment().add(1, "month").format("MMM DD,YYYY")}
              </div>

              <div style={{ fontSize: 18, fontWeight: 500 }}>Licenses</div>

              <div
                style={{
                  fontWeight: 500,
                  color: "rgba(0,0,0,0.45)",
                  marginBottom: 16,
                }}
              >
                {selectPlan}
              </div>

              <div style={{ fontSize: 18, fontWeight: 500 }}>Voucher Code</div>

              <Row style={{ marginBottom: 16 }}>
                <Col xs={24} md={24} xl={24}>
                  <Input
                    style={{
                      height: 30,
                      fontWeight: 500,
                      color: "rgba(0,0,0,0.45)",
                      //   border: `1px solid ${PrimaryColor}`,
                      borderRadius: 0,
                    }}
                    onChange={(e) => setVoucherCode(e.target.value)}
                  />
                </Col>
              </Row>

              <div style={{ fontSize: 18, fontWeight: 500 }}>Sub Total</div>

              <div
                style={{
                  fontWeight: 500,
                  color: "rgba(0,0,0,0.45)",
                  marginBottom: 16,
                }}
              >
                <Currency
                  quantity={selectPrice / 100}
                  currency={selectCurrency}
                  pattern="!###,###.00"
                />
              </div>

              <div
                style={{
                  marginBottom: 16,
                }}
              >
                <Row style={{ marginBottom: 8, fontWeight: 500, fontSize: 12 }}>
                  Receipt & details will send to your email
                </Row>

                <Row
                  onClick={() => setCheckTnc(!checkTnc)}
                  style={{
                    cursor: "pointer",
                    fontWeight: 500,
                    color: "rgba(0,0,0,0.35)",
                  }}
                >
                  <Col xs={1} md={1} xl={4}>
                    <Checkbox checked={checkTnc} />
                  </Col>

                  <Col xs={23} md={23} xl={20} style={{ textAlign: "justify" }}>
                    I agree that you can collect, use and disclose the
                    information provided by me in accordance with your
                    <a
                      style={{ color: PrimaryColor }}
                      rel="noreferrer"
                      href="https://finport.com.my/ftsb-terms-of-use/"
                      target="_blank"
                    >
                      {" "}
                      Terms & Conditions{" "}
                    </a>
                    which I have read and understand
                  </Col>
                </Row>
              </div>

              <Row>
                {userSubscription.length > 0 &&
                userSubscription[0].customerId ? (
                  <Button
                    danger={
                      selectPriceId === userSubscription[0].priceId &&
                      !userSubscription[0].cancelAtEndDate
                        ? true
                        : false
                    }
                    type="primary"
                    size={window.innerWidth < 1600 ? "middle" : "large"}
                    style={{
                      fontSize:
                        window.innerWidth < 1600
                          ? window.innerWidth < 1400
                            ? 10
                            : 12
                          : 14,
                      fontWeight: "bold",
                      width: "100%",
                    }}
                    disabled={
                      !selectPlan ||
                      !checkTnc ||
                      (selectPriceId === userSubscription[0].priceId &&
                        userSubscription[0].cancelAtEndDate)
                    }
                    onClick={() => {
                      if (selectPriceId === userSubscription[0].priceId) {
                        CancelSubscription(
                          userSubscription[0].subscriptionStatus
                        );
                      } else {
                        ChangeSubscription();
                      }
                    }}
                  >
                    {selectPriceId === userSubscription[0].priceId &&
                    !userSubscription[0].cancelAtEndDate
                      ? "Cancel Subscription"
                      : selectPriceId === userSubscription[0].priceId &&
                        userSubscription[0].cancelAtEndDate
                      ? "Cancelled"
                      : "Change subscription"}
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    size={window.innerWidth < 1600 ? "middle" : "large"}
                    style={{
                      fontSize:
                        window.innerWidth < 1600
                          ? window.innerWidth < 1400
                            ? 10
                            : 12
                          : 14,
                      fontWeight: "bold",
                      width: "100%",
                    }}
                    disabled={!selectPlan || !checkTnc}
                    onClick={() => HandleCheckOut()}
                  >
                    Proceed to Checkout
                  </Button>
                )}
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default withAppContext(BillingSubscriptionSpecial);
